// src/hooks/useApiKeys.js
// Hanya menyimpan preferensi provider (Gemini/Cohere)
// API Key sudah dikelola di Cloudflare Environment Variables

import { useState, useEffect } from 'react';

const STORAGE_KEY_PROVIDER = 'nahwu_ai_provider';

export function useApiKeys() {
  const [activeProvider, setActiveProvider] = useState('gemini');

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY_PROVIDER) || 'gemini';
    setActiveProvider(saved);
  }, []);

  const switchProvider = (provider) => {
    setActiveProvider(provider);
    localStorage.setItem(STORAGE_KEY_PROVIDER, provider);
  };

  return {
    activeProvider,
    switchProvider,

    // ── Nilai stub untuk kompatibilitas komponen lama ────────
    // Komponen yang masih menggunakan props ini tidak akan error
    geminiApiKey:    '',
    cohereApiKey:    '',
    cohereModel:     'command-r-08-2024',
    isDemoMode:      false,
    setGeminiApiKey: () => {},
    setCohereApiKey: () => {},
    setCohereModel:  () => {},
    saveSettings:    () => {},
    removeApiKey:    () => {},
  };
}

export default useApiKeys;